import React from "react";
import { Route, Redirect } from "react-router-dom";
import RouteNames from "../../routes/RouteNames";
import { Cookies } from "react-cookie";

export default ({ component: Component, ...rest }) => {
  const redirectToHook = (pattern, route, props) => {
    if (pattern.test(props.location.pathname)) {
      return <Component {...props} />;
    } else {
      return (
        <Redirect
          to={{
            pathname: route,
            state: {
              from: props.location,
            }
          }}
        />
      );
    }
  };

  return (
    <Route
      {...rest}
      render={(props) => {
        let browserCookies = new Cookies(),
          pattern = new RegExp("^" + RouteNames.PROFILE),
          b2bPattern = new RegExp("^" + RouteNames.B2B);
        if (browserCookies.get("loginToken")) {
          document.body.className = "";
          return redirectToHook(pattern, RouteNames.PROFILE, props);
        }

        document.body.className = "hide-chat";

        if (browserCookies.get("loginTokenB2b")) {
          return redirectToHook(b2bPattern, RouteNames.B2B, props);
        }

        if (
          b2bPattern.test(props.location.pathname) ||
          pattern.test(props.location.pathname)
        ) {
          return (
            <Redirect
              to={{
                pathname: RouteNames.LOGIN,
                state: {
                  from: props.location,
                },
              }}
            />
          );
        }

        return <Component {...props} />;
      }}
    />
  );
};
